import React from 'react';
import PageHero from '../components/PageHero';
import CompareSection from '../components/CompareSection';
import CTASection from '../components/CTASection';
import useDocumentTitle from '../hooks/useDocumentTitle';

const Compare = () => {
  useDocumentTitle({
    title: 'Compare',
    description:
      'Seven questions to gut-check whether your current EDI provider is keeping up. If the answers are uncomfortable, iConnect should be your next call.',
  });

  return (
    <>
      <PageHero
        eyebrow="Compare"
        title="How does iConnect"
        titleAccent="compare?"
        breadcrumbs={[{ label: 'Compare' }]}
        subhead="A quick gut-check on whether your current EDI provider is keeping up with your business. Run through these questions - if the answers are uncomfortable, let's talk."
      />
      <CompareSection />
      <CTASection />
    </>
  );
};

export default Compare;
